__turbopack_context__.v({
  "kit-price": "KitPrice-module-scss-module__VljKma__kit-price",
  "kit-price__discount": "KitPrice-module-scss-module__VljKma__kit-price__discount",
});
